<div class="mm-learning-history-chart" role="img">
    <canvas #learningChartCanvas ></canvas>
</div>
